const AggragatorIcon = () => {
  return (
    <svg
      id="Group_9460"
      data-name="Group 9460"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="28"
      viewBox="0 0 30 28"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5544"
            data-name="Rectangle 5544"
            width="30"
            height="28"
            fill="#707070"
          />
        </clipPath>
      </defs>
      <g id="Group_9459" data-name="Group 9459" clipPath="url(#clip-path)">
        <path
          id="Path_12184"
          data-name="Path 12184"
          d="M3.917,17.789a3.906,3.906,0,0,0,3.707-2.733h4.709a7.384,7.384,0,0,0-1.093,1.236,8.3,8.3,0,0,0-1.364,3.99,3.917,3.917,0,1,0,2.428.035,5.722,5.722,0,0,1,.926-2.635A5.236,5.236,0,0,1,14.8,16.2a7.856,7.856,0,0,1,2.664-1,9.322,9.322,0,0,1,.94-.129c.113-.008.2-.012.254-.014l.058,0h7.155L24.29,16.648a1.23,1.23,0,0,0,0,1.728,1.2,1.2,0,0,0,1.711,0l3.645-3.68a1.231,1.231,0,0,0,0-1.728L26,9.287a1.2,1.2,0,0,0-1.711,0,1.23,1.23,0,0,0,0,1.728l1.581,1.6H18.722A9.084,9.084,0,0,1,15.3,11.8a5.361,5.361,0,0,1-2.117-1.718,5.192,5.192,0,0,1-.881-2.4,3.919,3.919,0,1,0-2.428.035,7.728,7.728,0,0,0,1.381,3.84,7.148,7.148,0,0,0,.944,1.056H7.624A3.909,3.909,0,0,0,3.917,9.877a3.956,3.956,0,0,0,0,7.912m7.118,7.766a1.512,1.512,0,1,1,1.5-1.513,1.508,1.508,0,0,1-1.5,1.513m0-23.112a1.512,1.512,0,1,1-1.5,1.512,1.508,1.508,0,0,1,1.5-1.512M3.917,12.321a1.512,1.512,0,1,1-1.5,1.512,1.508,1.508,0,0,1,1.5-1.512"
          transform="translate(0 0.001)"
          fill="#707070"
        />
      </g>
    </svg>
  )
}

export default AggragatorIcon
